import { useRef } from 'react';

/**
 * returns last value and rejects the invalid one.
 * @param value the changing value
 * @param validator a method to validate the value
 */
export const useLastValid = <T>(value: T, validator: (v: T) => boolean): T | undefined => {
  const ref = useRef<T>();

  if (validator(value)) {
    ref.current = value;
  }

  return ref.current;
};
